module.exports = __webpack_public_path__ + "static/media/womens4.896dab32.jpg";